import { Instance, SnapshotOut, types } from 'mobx-state-tree';

/**
 * # HypotensionResults
 *
 * HypotensionResults을 설명하세요.
 */
export const HypotensionResults = types
  .model('HypotensionResults')
  // --------------------------------------------------------------------------
  .props({
    hypTf: types.optional(types.number, 0), //  저혈압 예측 결과 (0/1)
    hypProb: types.optional(types.string, ''), //  저혈압 예측 결과 (확률)
    hypStr: types.optional(types.string, ''), //  저혈압 예측 결과 (정상/저혈압)
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model hypotensionResults --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as IHypotensionResults;
      (Object.keys(newProps) as THypotensionResultsKeys[]).forEach((key) => {
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type THypotensionResults = Instance<typeof HypotensionResults>;
type THypotensionResultsSnapshot = SnapshotOut<typeof HypotensionResults>;

export interface IHypotensionResults extends THypotensionResults {}
export type THypotensionResultsKeys = keyof THypotensionResultsSnapshot & string;
export interface IHypotensionResultsSnapshot extends THypotensionResultsSnapshot {}
export const createHypotensionResults = () =>
  types.optional(HypotensionResults, {} as THypotensionResults);
